import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { DirectAddService } from '@app/modules/direct/services/direct-add.service';
import { DirectService } from '@app/modules/direct/services/direct.service';
import { DeviceDetectionService } from '@app/shared/services/device-detection/device-detection.service';

@Component({
  selector: 'sbnb-direct-add-subdomain',
  templateUrl: './direct-add-subdomain.component.html',
})
export class DirectAddSubdomainComponent implements OnInit {
  availableSubdomains: string[] = [];
  loading = false;

  form = new UntypedFormGroup({
    subdomain: new UntypedFormControl('', [Validators.required]),
    domain: new UntypedFormControl('', [Validators.required]),
  });

  user = this.auth.getUserDetails();
  isMobile$ = this.deviceDetectionService.isMobileViewport();

  constructor(
    private readonly direct: DirectService,
    private readonly auth: AuthenticationService,
    public readonly directAddService: DirectAddService,
    private readonly deviceDetectionService: DeviceDetectionService
  ) {}

  ngOnInit() {
    this.getSubdomainChoices();
  }

  getSubdomainChoices() {
    this.direct.getSubdomains().subscribe((subdomains) => {
      const hospitableRentals = subdomains.find((s) => s.includes('hospitable.rentals'));

      this.form.patchValue({
        subdomain:
          this.user.company.toLowerCase().replace(/\s/g, '') || this.user.first_name.toLowerCase().replace(/\s/g, ''),
        domain: hospitableRentals || subdomains[0],
      });

      this.availableSubdomains = subdomains;
    });
  }

  checkDomainAvailability() {
    this.loading = true;

    this.direct.checkDomainAvailability(`${this.form.value.subdomain}.${this.form.value.domain}`).subscribe(
      () => this.directAddService.setSiteDomain(this.form.value),
      () => {
        this.loading = false;
        this.form.controls.subdomain.setErrors({
          custom: 'This domain is not currently available. Please choose another one.',
        });
      }
    );
  }
}
